import { h, Component } from 'preact'
import Utils from '../utils'

class SVG extends Component {
  render() {
    let { name, size, width, height } = this.props

    size || (size = 24)
    width || (width = size)
    height || (height = size)

    let style = { width, height }

    return (
      <i class={`icon icon-${name}`} style={style}>
        <svg style={{ width: width, height: height }}>
          <use xlinkHref={`#${name}`} />
        </svg>
      </i>
    )
  }
}

export default SVG
